import React from 'react';
import { useTranslation } from 'react-i18next';

interface Benefit {
  icon: React.ElementType;
  title: string;
  text: string;
}

interface KeyBenefitsProps {
  benefits: Benefit[];
  title?: string;
}

const KeyBenefits: React.FC<KeyBenefitsProps> = ({ benefits, title }) => {
  const { t, ready } = useTranslation();
  if (!ready) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
      {benefits.map((benefit, index) => {
        const Icon = benefit.icon;
        return (
          <div key={index} className="flex flex-col items-center text-center bg-white shadow-md rounded-lg p-6">
            <div className="bg-[#025f99] text-white p-4 rounded-full mb-4">
              <Icon className="text-white text-3xl" />
            </div>
            <h3 className="text-lg font-semibold mb-2 text-gray-900 mt-4">{t(`benefits.${benefit.title}.title`)}</h3>
            <p className="text-gray-600">{t(`benefits.${benefit.title}.text`)}</p>
          </div>
        );
      })}
    </div>
  );
};

export default KeyBenefits;

